import type { ElementRef } from '@angular/core';
import {
  Component,
  forwardRef,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import type { FormViewAdapter } from 'ngrx-forms';
import { NGRX_FORM_VIEW_ADAPTER } from 'ngrx-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import type { CheckboxItem } from './checkbox-set.model';

@Component({
  selector: 'wl-checkbox-set',
  templateUrl: './checkbox-set.component.html',
  styleUrls: ['./checkbox-set.component.scss'],
  providers: [
    {
      provide: NGRX_FORM_VIEW_ADAPTER,
      useExisting: forwardRef(() => CheckboxSetComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [AutomationIdDirective],
})
export class CheckboxSetComponent implements FormViewAdapter {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() checkboxItems: CheckboxItem[] = [];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() inline = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() name?: string;

  value: string[] = [];

  @ViewChildren('input')
  public inputs!: QueryList<ElementRef<HTMLInputElement>>;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (_value: any): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = (): void => {};

  setViewValue(value: string[]): void {
    this.value = value;
  }
  setOnChangeCallback(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  setOnTouchedCallback(fn: () => void): void {
    this.onTouched = fn;
  }

  onInputChanged(): void {
    const value = this.inputs
      .filter((input) => input.nativeElement.checked)
      .map((input) => input.nativeElement.value);

    this.value = value;
    this.onChange(value);
  }
}
